import { Wrapper } from "./Actions.styled";
import { AiOutlineBell } from "react-icons/ai";
import { IoDocumentTextOutline } from "react-icons/io5";
import { BiCertification, BiUserCircle } from "react-icons/bi";

const Actions = () => {
  const actions = [
    {
      title: "Create your account",
      icon: BiUserCircle,
      href: "https://www.new-job-today.co.uk/register/",
    },
    {
      title: "Get job alerts",
      icon: AiOutlineBell,
      href: "https://www.new-job-today.co.uk/newalert/",
    },
    {
      title: "Upload your cv",
      icon: IoDocumentTextOutline,
      href: "https://www.new-job-today.co.uk/logon/?PipelinedPage=%2fprofile%2f",
    },
    {
      title: "Search your courses",
      icon: BiCertification,
      href: "https://www.new-job-today.co.uk/register/",
    },
  ];
  return (
    <Wrapper>
      {actions.map((action, i) => {
        return (
          <a
            key={i}
            href={action.href}
            target="_blank"
            rel="noopener noreferrer"
            className="action"
          >
            {<action.icon />}
            {action.title}
          </a>
        );
      })}
    </Wrapper>
  );
};

export default Actions;
